module.exports = __webpack_public_path__ + "img/hu.bbddd29d.svg";